class CustomAudioPlayer extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const audioContainer = this.querySelector('.audio-container');
        const playButton = this.querySelector('.audio-button.play');
        const pauseButton = this.querySelector('.audio-button.pause');
        const audioPlayer = this.querySelector('.audio-player');
        const audioElement = this.querySelector('audio');
        const audioCollezione = document.querySelector('.audio-collezione');

        if (!audioContainer || !playButton || !audioPlayer || !audioElement || !pauseButton) {
            console.warn("CustomAudioPlayer: Missing required elements inside wrapper.");
            return;
        }

        // Play on play button click
        playButton.addEventListener('click', (e) => {
            e.preventDefault();
            // Pause other audio-collezione if playing
            if (audioCollezione && !audioCollezione.paused) {
                audioCollezione.pause();
            }
            audioContainer.classList.add('playing');
            audioElement.focus();
            audioElement.play();
        });

        pauseButton.addEventListener('click', (e) => {
            e.preventDefault();
        });

        // Collapse when audio ends
        audioElement.addEventListener('ended', () => {
            setTimeout(() => {
                audioContainer.classList.remove('playing');
            }, 1000);
        });

        // Handle focus loss
        audioElement.addEventListener('blur', () => {
            if (!audioElement.paused) {
                audioElement.pause();
            }
            setTimeout(() => {
                if (!audioPlayer.contains(document.activeElement)) {
                    audioContainer.classList.remove('playing');
                }
            }, 100);
        });

        // Keyboard support for play button
        playButton.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                playButton.click();
            }
        });

        // Escape key to collapse
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && audioContainer.classList.contains('playing')) {
                audioContainer.classList.remove('playing');
                playButton.focus();
            }
        });
    }
}

customElements.define('custom-audio-player', CustomAudioPlayer);
